module.exports = {
	"pagination": {
		"DescribeStackEvents": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "StackEvents"
		},
		"DescribeStackResources": {
			"result_key": "StackResources"
		},
		"DescribeStacks": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "Stacks"
		},
		"ListStackResources": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "StackResourceSummaries"
		},
		"ListStacks": {
			"input_token": "NextToken",
			"output_token": "NextToken",
			"result_key": "StackSummaries"
		}
	}
};


//////////////////
// WEBPACK FOOTER
// ./~/aws-sdk/apis/cloudformation-2010-05-15.paginators.json
// module id = 645
// module chunks = 2